import NiceModal from '@ebay/nice-modal-react';
import { FC, createElement, useEffect, useRef } from 'react';
import IgnoreCustomCharacter from './DocCompare/IgnoreCustomCharacter';
import IgnorePunctuation from './DocCompare/IgnorePunctuation';

interface IProps {
  visible: boolean;
  workspaceId?: string;
  onCancel: () => void;
  onSuccess: (taskCode: string) => void;
}

export const CompareTask: FC<IProps> = (props) => {
  const { visible, workspaceId = '', onCancel, onSuccess } = props;
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleClose = () => {
      onCancel();
    };
    const handleSuccess = (value: Event) => {
      onSuccess((value as CustomEvent<string>).detail);
    };

    const handleSetCustom = (value: Event) => {
      // 0 标点符号  1自定义字符
      const type = (value as CustomEvent<string>).detail;
      if (type === '0') {
        NiceModal.show(IgnorePunctuation);
        console.log('123');
      } else if (type === '1') {
        NiceModal.show(IgnoreCustomCharacter);
      }
    };

    ref.current?.addEventListener('onSetCustom', handleSetCustom);
    ref.current?.addEventListener('onClose', handleClose);
    ref.current?.addEventListener('onSuccess', handleSuccess);
    return () => {
      ref.current?.removeEventListener('onSetCustom', handleSetCustom);
      ref.current?.removeEventListener('onClose', handleClose);
      ref.current?.removeEventListener('onSuccess', handleSuccess);
    };
  }, [visible, onCancel, onSuccess]);

  return (
    <div className="w-full h-full">
      {createElement('app-compare-task', {
        ref: ref,
        visible: visible ? 'true' : '',
        'workspace-id': workspaceId,
      })}
    </div>
  );
};
